import React, { useRef, useState, useEffect, useContext } from 'react';
import useHttpApiCall from '../../../services/useHttpApiCall';
import KpiLayoutComponent from '../components/kpilayout.component';
import { context as KpiContext } from '../../../context/kpi.context';
import {
  chartCommonConfig,
  chartTitleConfig,
  chartSubtitleConfig,
  chartYaxisConfig
} from '../../../config/chartCommon';
import { useSelector } from 'react-redux';
import eventFire from '../../../utilities/eventFire-inside-highcharts';
// import {  useSearchParams } from 'react-router-dom';
import { context as ProcessContext } from '../../../context/process.context';
import { useSearchParams } from 'react-router-dom';
export default function KpiOneContainer(props) {

 // console.log("kpi props",props )
  // const [chartData, setChartData] = useState(undefined);
  const charRef = useRef(undefined);
  //  const [horScroll, setHorScroll] = useState(undefined);
  const [payload, setPayload] = useState(undefined);
  const [chartApiData, setChartApiData] = useState(null);
  const [xaxisList, setXaxisList] = useState([]);

  var fetchKpiLinks = useContext(KpiContext).fetchKpiLinks;
  var kpiSharedList = useContext(KpiContext).state.kpiLinks;
  const userAccessibility = useSelector((state) => state.userAccessibility.set_user_accessibility);
  const flexibleEquipmentEnabled =
    localStorage.getItem('flexible_equipment') == 'true' ? true : false;
  let processList = useContext(ProcessContext).state.sidebarLinks?.layers;
  let [searchParams] = useSearchParams();
  let plant_code = searchParams.get('plant_code');

  useEffect(() => {
   // console.log(props);
    if (props.kpi_id) {
      flexibleEquipmentEnabled
        ? setPayload({
            auth: true,
            url: flexibleEquipmentEnabled
              ? 'v0/layers/company/kpis/graphs/'
              : 'v0/company/kpis/graphs/',
            params: {
              kpi_id: props.kpi_id,
              layer_type: 'plant'|| props.layer_type,
              plant_code: plant_code || processList?.[0].plant_code || props.plant_code
            }
          })
        : setPayload({
            auth: true,
            url: flexibleEquipmentEnabled
              ? 'v0/layers/company/kpis/graphs/'
              : 'v0/company/kpis/graphs/',
            params: { kpi_id: props.kpi_id }
          });
    }
  }, [props.kpi_id, kpiSharedList.updateKpiGraph, kpiSharedList.updateSetKpiGraph, plant_code]);

  const [data] = useHttpApiCall(payload);
  useEffect(() => {
    if (data && data.data) {
      setChartApiData(data.data.data);
    }
  }, [data]);

  // useEffect(() => {
  //   if (chartApiData && chartApiData.categories.length > 15) {
  //     setHorScroll(1000);
  //   }
  // }, [chartData]);

  useEffect(() => {
    let tempXaxisList = [];
    if (chartApiData && charRef && charRef.current) {
      charRef.current.chart.series[0].data.forEach(function (p) {
        if (p.y == 0.0) {
          p.update({
            color: 'red',
            className: 'value-present'
          });
          tempXaxisList.push(p.name);
        } else {
          p.update({
            color: '#71B2FF',
            className: 'value-absent'
          });
        }
      });
      setXaxisList(tempXaxisList);
    }
  }, [chartApiData, charRef]);

  const config = {
    ...chartTitleConfig({
      graphTitle: props.graph_name||`Energy use (kWh) / ${(chartApiData && chartApiData.kpi_name) || ''} (${
        (chartApiData && chartApiData.kpi_unit_name) 
      })`,
      userAccessibility: userAccessibility
    }),
    ...chartSubtitleConfig({ chartApiData: chartApiData, userAccessibility: userAccessibility }),
    ...chartCommonConfig,
    chart: {
      // type: "column",
      spacingBottom: 10,
      className: 'process-energy-use',
      // scrollablePlotArea: {
      //   minWidth: horScroll,
      // },
      zoomType: 'null',
      style: {
        fontFamily: 'Poppins',
        color: '#4E4E4E'
      }
    },

    tooltip: {
      useHTML: true,
      pointFormat: '<div class="semi-bold">{point.y}</div>',
      valueSuffix: ` kWh/${chartApiData && chartApiData.kpi_unit_name}`,
      valueDecimals: 2,
      formatter: function () {
        let name = !props?.idParams?.equipment_id
          ? `<div class="txt-10">${this.point.name}</div>`
          : '';
        let energyUse = `<br><div class="txt-10">Energy use: ${
          this.point.energy_usage?.toFixed(2) || 0
        } kWh
        </div>`;
        let productionHours = `<br><div class="txt-10">${chartApiData?.kpi_name}: ${
          this.point.kpi?.toFixed(2) || 0
        } ${chartApiData?.kpi_metric_unit || chartApiData?.kpi_unit_name}
        </div>`;
        // Production hours

        return `<div style=" line-height:10px" class="customTooltip">
        ${name}<br>
        <div class=" " >
        <span class="semi-bold">${this.y.toFixed(2)} kWh/${
          chartApiData && chartApiData.kpi_unit_name
        }</span>
        </div>
        <div>
        ${energyUse} ${productionHours}
        </div>
        </div>`;

        // return `${name}<br><span class=" txt-10"></span><div class="semi-bold">${this.y.toFixed(
        //   2
        // )} kWh/${
        //   chartApiData && chartApiData.kpi_unit_name
        // }</div>${energyUse} ${productionHours}`;
      }
    },

    exporting: {
      chartOptions: {
        subtitle: {
          text: ''
        },
        plotOptions: {
          series: {
            dataLabels: {
              enabled: true,
              format: '{point.y:,.2f}'
            }
          }
        }
      }
    },

    plotOptions: {
      column: {
        cursor: 'pointer',
        color: '#71B2FF',
        minPointLength: 5,
        point: {
          events: {
            click: function (data) {
              if (data.point.y == 0.0) {
                kpiSharedList = {
                  ...kpiSharedList,
                  openSetKpiMonth: data.point.name,
                  openKpiScreen: true,
                  editKpiShow: true
                };
                fetchKpiLinks(kpiSharedList);
              }
            }
          }
        }
      }
    },
    xAxis: {
      type: 'category',
      lineColor: '#cccccc',
      labels: {
        formatter: function () {
          if (xaxisList.includes(this.value)) {
            return `<span class="no-value" style="fill: red;">${this.value}</span>`;
          } else {
            return `<span style="fill:#666;">${this.value}</span>`;
          }
        },

        padding: 10,
        autoRotation: undefined,
        // step:1,
        events: {
          click: function () {
            if (this.value.includes('no-value')) {
              var xaxisLableElement = document.querySelectorAll(
                '.process-energy-use .highcharts-point'
              )[this.pos];
              eventFire(xaxisLableElement, 'click');
            }
          }
        }
      },
      tickLength: 0
    },
    ...chartYaxisConfig({ userAccessibility }),
    series: [
      {
        data: chartApiData && chartApiData.data,
        // data:[["june",0],["july",4]],
        // name:`Total: ${2010}kWh`,
        type: 'column'
      }
    ]
  };
  return (
    <div>
      <KpiLayoutComponent
        chartApiData={chartApiData}
        chartData={config}
        charRef={charRef}
        expandWindow={props.expandWindow}
        minimizeWindow={props.minimizeWindow}
        shouldExpand={props.shouldExpand}
        // hasExpand = {props.hasExpand} onExpand = {props.onExpand} onMinimize = {props.onMinimize} downloadChart={downloadChart}
        chartId={props.id}
      />
    </div>
  );
}
